// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__i5uBB","fullWidth":"Tabs_fullWidth__VXQlx"};